import type { UseFormReturn } from 'react-hook-form';
import { Labeled, Select } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { ITabsSettingsFormValues } from './TabsSettingsForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { getTabProps } from './helpers';

export type ITabsSettingsFormStartSectionProps = IContainerProps & {
  form: UseFormReturn<ITabsSettingsFormValues>;
};

export const TabsSettingsFormStartSection: React.FC<
  ITabsSettingsFormStartSectionProps
> = (props) => {
  const { sx, form } = props;

  const { t } = useTranslation();
  const tabIds = form.watch('tabIds');

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t('TabsSettingsFormStartSection.fields.startTab.label')}
        supportingText={t(
          'TabsSettingsFormStartSection.fields.startTab.supportingText',
        )}
        required
      >
        <FormField
          name="startTabId"
          control={form.control}
          as={Select}
          forwardError
          items={
            tabIds
              ?.map((tabId) => getTabProps(tabId, t))
              .map(({ id, icon, label, supportingText }) => ({
                value: id,
                label,
                icon,
                supportingText,
              })) ?? []
          }
        />
      </Labeled>
    </FormSection>
  );
};
